import { Injectable } from '@angular/core';
import { LMPersonalizationPersistenceService } from '@services/lm-personalization-persistence.service';

@Injectable()
export class LMListPersonalizationService {
  constructor(private lmPersonalizationPersistenceService: LMPersonalizationPersistenceService) {}

  public getListPersonalization(listPersonalizationKeyParams: LMListPersonalizationKeyParams): LMListPersonalization {
    return this.lmPersonalizationPersistenceService.getPersonalization(listPersonalizationKeyParams.getKey());
  }

  public saveListPersonalization(listPersonalizationKeyParams: LMListPersonalizationKeyParams, listPersonalizationItem: LMListPersonalization): void {
    this.lmPersonalizationPersistenceService.persistPersonalization(listPersonalizationKeyParams.getKey(), listPersonalizationItem);
  }

  public deleteListPersonalization(listPersonalizationKeyParams: LMListPersonalizationKeyParams): void {
    this.lmPersonalizationPersistenceService.removePersonalization(listPersonalizationKeyParams.getKey());
  }
}

export class LMListPersonalizationKeyParams {
  prefix?: string;
  resourceId: string;
  dataArea: string;
  actorId?: string;
  contextResourceId?: string;

  private key = '';

  getKey() {
    if (!this.key) {
      this.buildKey();
    }
    return this.key;
  }

  private buildKey(): void {
    if (this.prefix) {
      this.key += this.prefix + '_';
    }

    this.key += this.dataArea + '_' + this.resourceId.replace('.', '_');

    if (this.contextResourceId) {
      this.key += '_' + this.contextResourceId.replace('.', '_');
    }

    if (this.actorId) {
      this.key += '_' + this.actorId;
    }
  }
}
